<template>
    <div id="top" class="top">
        <div class="bg">
            <div class="content relative h-100">
                <div class="backToEdu myflex-v" @click="back"><i class="el-icon-back backIcon"></i>返回上一页</div>
                <div class="logo">
                    <div class="logo-font logo-font3">全民终身学习教育资源共享行动</div>
                    <div class="logo-font logo-font1">（艺术类）</div>
                    <div class="logo-font logo-font2 mt5">Research and practice project of the Ministry of education on the institutionalization and standardization of community education and elderly education (Art)</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .top{height:310px;}
    .bg{width:100%;height:300px;position:relative;background:url(../../assets/img/bg.png) no-repeat center;-webkit-background-size:auto 100%;background-size:auto 100%;
    z-index:1;}
    .logo{position:absolute;top:90px;left:0;}
    .logo-font{color:#000;text-shadow:0 0 2px #fff;}
    .logo-font1{font-size:24px;}
    .logo-font2{font-size:12px;font-weight:600;letter-spacing: 1.1px;display:none;}
    .logo-font3{font-size:32px;margin-bottom:12px;font-weight:600;}
    .backToEdu{background:rgba(255,255,255,.2);cursor:pointer;color:#333;font-size:14px;position:absolute;top:20px;left:0;padding:5px 10px;border-radius:4px;}
    .backToEdu:hover{background:rgba(255,255,255,.4)}
    .backIcon{color:#666;font-size:14px;border:1px solid #666;border-radius:50%;margin-right:5px;}

    @media screen and(max-width:1200px){
        .bg{padding:0 15px;}
    }
    @media screen and(max-width:750px){
        .logo-font1{font-size:21px;}
        .logo-font3{font-size:30px;}
    }
    @media screen and(max-width:640px){
        .logo-font1{font-size:19px;}
        .logo-font3{font-size:29px;}
    }
    @media screen and(max-width:450px){
        .logo-font1{font-size:18px;}
        .logo-font3{font-size:25px;}
    }
    @media screen and(max-width:400px){
        .logo-font1{font-size:17px;}
        .logo-font3{font-size:21px;}
    }
    @media screen and(max-width:340px){
        .logo-font1{font-size:15px;}
        .logo-font3{font-size:20px;}
        .logo{top:80px;}
    }
</style>

<script>
import base from '@/api/base';
export default {
    name: "top",
    components: {
    },
    props: ['index'],
    data(){
        return {
        }
    },
    methods:{
        back(){
            //从成教网站caea-art.cn跳过来
            let fromCaeaArt = this.$route.query.fromCaeaArt;
            if(fromCaeaArt){
                location.replace(base.caeaUrl);
            }
            else{
                if(this.index){
                    location.href = 'http://www.shequ.edu.cn';
                }else{
                    this.$router.push({name: 'index'})
                }
            }
        }
    },
    mounted(){
        console.log(this.$route.query.fromCaeaArt,'this.$route.query.fromCaeaArt')
    }
}
</script>